module.exports = __webpack_public_path__ + "img/dku.02680.7a90e6be.png";